export const NEW = 'new'
export const PROGRESS = 'progress'
export const COMPLETED = 'completed'

export const PURCHASE_ORDER = 'PurchaseOrder'
export const STOCK = 'StockTransfer'
export const RETURN = 'Returns'

export const FILTER_NAME = 'receive'
